module.exports = __webpack_public_path__ + "static/49-0f0291727ee170eb29eee94ff626f392.png";